import { formatISO } from './date';

export const getInvoiceDescription = (
  item: Record<string, any>,
  showOvertime: boolean,
) => {
  const {
    shortDescription = '',
    skill,
    isEdited,
    cancelled,
    isOvertime,
    isHoliday,
  } = item;
  const skillName = skill?.name || '';
  const isEditedandSkill = isEdited && skillName;
  let description = skillName || shortDescription;

  if (showOvertime && isOvertime) {
    description = isHoliday
      ? `HOLIDAY OVERTIME: ${skillName}`
      : `OVERTIME: ${skillName}`;
  } else if (isEditedandSkill || cancelled) {
    description = `${skillName} - ${shortDescription}`;
  }
  if (isHoliday && !isOvertime) {
    description = 'HOLIDAY: ' + description;
  }
  return description;
};

export const getRateDesc = (
  item: Record<string, any>,
  showOvertime: boolean,
) => {
  const { isOvertime, isHoliday } = item;
  let rateDesc = '';
  if (showOvertime && isOvertime) {
    rateDesc = isHoliday ? `Holiday Overtime` : `Overtime`;
  } else if (!isOvertime && isHoliday) {
    rateDesc = 'Holiday Rate';
  }
  return rateDesc;
};

const isNumberDecimal = (num: number) => num % 1 !== 0;

export const formatNetTime = (netTime: number | string | null) => {
  const netTimeInt = Number(netTime);
  if (netTimeInt) {
    const netTimeHours = netTimeInt / 60;
    return isNumberDecimal(netTimeHours)
      ? netTimeHours.toFixed(2)
      : netTimeHours;
  } else return netTime;
};

export const formatApproveTime = (
  approveTime: string | null,
  timezone = 'America/New_York',
) => {
  if (!approveTime) return '';
  return formatISO(approveTime, 'p', timezone).toLowerCase();
};

export const formatNetTimeInHrAndMin = (approvedMinutes: number) => {
  // Convert minutes to decimal hours
  const totalHours = approvedMinutes / 60;

  // Truncate to 2 decimal places (not round)
  // Multiply by 100, floor it, then divide by 100 to truncate
  const truncatedHours = Math.floor(totalHours * 100) / 100;

  // Format to ensure 2 decimal places are always shown
  return truncatedHours.toFixed(2);
};
